import { Stack } from "@mui/material";
import { DateLocalizer } from "react-big-calendar";

import { useCalendarContextOptional } from "@/common/contexts/calendar";

import AppTypography from "../Text/AppTypography";
import { GenericCalendarEntry } from "./Calendar";
import { RBCEventSimulatedCustom } from "./RectBigCalendarCustomComponents/RBCEventSimulatedCustom";

export interface CalendarMonthDayEntriesDetailsProps<TEntry extends GenericCalendarEntry> {
  /** Day of month. */
  slotDate: Date;
  /** All entries. */
  entries: TEntry[];
  /** Entries not visible on month view of the day. */
  remainingEntries: TEntry[];
  /** RBC localizer. */
  localizer: DateLocalizer;
}

/** Detailed view for: month view -> day cell -> show more button -> popover -> content. */
export function CalendarMonthDayEntriesDetails<TEntry extends GenericCalendarEntry>({
  slotDate,
  entries,
  localizer,
}: CalendarMonthDayEntriesDetailsProps<TEntry>) {
  const calendarContext = useCalendarContextOptional();

  return (
    <Stack gap={2} sx={{ py: 1, px: 2, pr: 0 }}>
      <AppTypography variant='subtitle1'>
        {localizer.format(slotDate, "dayHeaderFormat")}
      </AppTypography>

      <Stack gap={0.5} sx={{ pr: 2, maxHeight: { xxs: 200, md: 300 }, overflowY: "auto" }}>
        {entries.map((entry, i) => (
          <RBCEventSimulatedCustom
            key={i}
            event={entry}
            localizer={localizer}
            onSelect={(entry2, e) => {
              calendarContext?.openEntryViewPopover({
                entry: entry2,
                anchorEl: e.target as HTMLElement,
              });
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
